import { setIn } from "helpers/objUtils";
import { DimensionsPanelReduxState } from "../dimensions-panel";

export const forceShowDoorsOnHOF = <T extends (state: DimensionsPanelReduxState, ...args: any[]) => any>(
    func: T,
): ((...funcArgs: Parameters<T>) => ReturnType<T>) => {
    return (...args: Parameters<T>) => {
        const [state, ...restArgs] = args;
        const mutatedState = setIn(state, "showDoors", true);

        return func(mutatedState, ...restArgs);
    };
};
